import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { forkJoin } from 'rxjs';
import { LabReports, LabResult } from 'src/app/models';
import {  logoString } from 'src/app/models/water-lab/lab-report';
import { LabRequisitionService, MessageService, ReportsService } from 'src/app/services';
import * as ZoneMoment from "moment-timezone";
import { CustomDatePipe } from 'src/app/pipes';
var pdfMake = require("pdfmake/build/pdfmake");
var pdfFonts = require("pdfmake/build/vfs_fonts");
pdfMake.vfs = pdfFonts.vfs;
var htmlToPdfmake = require("html-to-pdfmake");
@Component({
  selector: 'bart-lab-report',
  templateUrl: './lab-report.component.html',
  styleUrls: ['./lab-report.component.scss'],
  providers:[CustomDatePipe]
})
export class LabReportComponent implements OnInit {
  @Output() pageLoadCompletedEvent = new EventEmitter();
  @Input() facilityMasterId:number;
  @Input() LabReportId : string;
  @Input() LabReportURL : string; 
  @Input() showSignature : boolean;
  @Input() printPDFSubHeader : string;
  @Input() showDateRageForPDF : string;  
  @Input() hideStatus : boolean;
  @Input () reportTitle : string;
  labResultsPrint :LabResult[]=[]
  facilityDetails: any;
  labResultColumn:any[];
  maxDate: Date;
  minDate: Date;
  EquipmentDisplayName: string;
  labReportData: LabReports[];
  facilityDisplayName:string;

  
  constructor
  (  
    private _labRequisitionService: LabRequisitionService,
    private _messageService: MessageService,
    private customDatePipe :CustomDatePipe,
    private _ReportsService : ReportsService
  ) 
  {
  }

  //OneV-732258  Lab report pdf
  ngOnInit() {
    this.labResultColumn =
      [
        { field: 'EquipmentDisplayName', header: 'MODEL # | NICKNAME | SERIAL # | EQUIPMENT ID', display: 'table-cell', width: "22%" },
        { field: 'TestDisplayName', header: 'TEST ID | NAME', display: 'table-cell', width: "15%" },
        { field: 'LabResult', header: 'RESULT | UNIT', display: 'table-cell', width: "10%" },
        { field: 'Status', header: 'STATUS', display: this.hideStatus ? 'none': 'table-cell', width: "10%" },
        { field: 'DrawDate', header: 'DRAW DATE', display: 'table-cell', width: "13%" },
        { field: 'LabComments', header: 'LAB COMMENTS', display: 'table-cell', width: "20%" },
        { field: 'LabRequisitionNumber', header: 'REQUISITION ID', display: 'table-cell', width: this.hideStatus ? "21%": "10%" },
      ];
     
      this.getLabReportData(this.LabReportId,this.LabReportURL)
    
  }

  populatePDFData(){
    this.facilityDetails = [];
    let getFacilityParam = {
      "GETFACILITYINFO": {
        "facilityMasterId": this.facilityMasterId
      }
    }
    const FacilityDetailsUrl = this._labRequisitionService.getfacilityDetails(JSON.stringify(getFacilityParam));   
    const requestsArray = [];
    requestsArray.push(FacilityDetailsUrl);
    forkJoin(requestsArray).subscribe((response: any) => 
    {
      if(response!=null && response[0].length)
      {
        this.facilityDetails = response[0][0];
        this.facilityDisplayName = this.facilityDetails.FacilityNumber  +" - " + this.facilityDetails.FacilityName
      }      
      this.createPDF();
    }, 
    (error) => 
    {
      this._messageService.setErrorPageMessage('Error Occurred while loading Master Data');
    });
  }

  getLabReportData(reportId,reportUrl){
    let argList="";
    let arrQueryParam=reportUrl.split("?")
    if(arrQueryParam.length>0)
    {
      argList=arrQueryParam[1].replace(/&/g, '|');
    }
    let runReportParam=  {
      "GETREPORTREPORTID":
        {
          "reportId":reportId
        },
        "RUNREPORT":{
          "ReportID":reportId,
          "ParamList":argList
        }
    }
    if(runReportParam!=null)
    {
      runReportParam.GETREPORTREPORTID.reportId=reportId;
      runReportParam.RUNREPORT.ReportID=reportId;

      var request = runReportParam
      this._ReportsService.runReport(JSON.stringify(request))
          .subscribe((runReportResponse:any)=>
          {   

            if(runReportResponse.errors!=null && runReportResponse.errors!=undefined)
            {
              alert(runReportResponse.errors);
              this.pageLoadCompletedEvent.emit();
              return;
            }
            else{
              if(this.hideStatus){
                let reportRessponse = runReportResponse.RUNREPORT;
                this.labReportData = reportRessponse.map(data =>{
                 return  {
                    LabRequisitionNumber : data.LabRequisitionNumber,
                    TestDisplayName : data.TestDisplayName ,
                    EquipmentDisplayName : data.EquipmentDisplayName ,
                    LabResult : data.LabResult ,
                    LabComments : data.LabComments ,
                    DrawDate : data.DrawDate ,
                  }
                 
                })
              }else{
                this.labReportData = runReportResponse.RUNREPORT;
                this.labReportData.forEach(item => {
                  item.DrawDate=this.customDatePipe.transform(item.DrawDate,"local","MM/dd/yyyy");
                })
                }  
            }   
          },
          (resp)=>
            {
              alert(resp.error.errors);
              this.pageLoadCompletedEvent.emit();
              return;
            })
    }
    this.populatePDFData();
  }
  createPDF(){ 
    let printDate=new Date();
    var timeZoneOffset =printDate.getTimezoneOffset();
    var timeZone = ZoneMoment.tz.guess();
    let currentTimezone =  ZoneMoment.tz.zone(timeZone).abbr(timeZoneOffset);
    let printFooterDate=this.customDatePipe.transform(printDate,"calender","MM/dd/yyyy H:mm:ss")+" "+currentTimezone 
    // let printFooterDate=this.customDatePipe.transform(this.printDate,"calender","MM/dd/yyyy H:mm:ss")
    let showSignature=this.showSignature;
    let footerLine1=this.facilityDisplayName;
    let footerLine2=[this.facilityDetails.Address1, this.facilityDetails.City, this.facilityDetails.State, this.facilityDetails.Zip].filter(Boolean).join(", "); 
    
     setTimeout(() => {
        try{
        var html = htmlToPdfmake(document.getElementById('printLabReprt').innerHTML, {
          tableAutoSize: true
        }
        );
        var dd = {
          info: {
            title: this.reportTitle,
          },
          pageMargins: [ 35, 35, 35, this.showSignature?167:80 ],
          content: html,
          pageSize:'LETTER',
          pageOrientation: 'landscape',
          images:html.images,
          pageBreakBefore: function (currentNode:any) {
            return currentNode.style && currentNode.style.indexOf('pdf-pagebreak-before') > -1;
          },
          imagesByReference: true,
          removeExtraBlanks : true,
          header: function(currentPage, pageCount, pageSize) {
            // computations...
            return {
              columns: [
                {
                  width: '92%',
                  text:[' ',' ',
                     'Lab Results '
                    ],
                  alignment:'left',
                  margin:[35,20,35,5]
                },
                {
                   image: logoString, 
                   
                   width: 50,
                   height : 20,
                   alignment:'right',
                   margin:[30,12,5,5]
                },
              ],
            };
          },
          footer: function(currentPage, pageCount) { 
            if(!showSignature){
              return  [
                {                
                  columns:[                  
                          { width:'100%',
                                        stack:[
                                          {
                                            canvas: [
                                              {
                                                  type: 'line',
                                                  x1: 30,
                                                  y1: 30,
                                                  x2: 755,
                                                  y2: 30,
                                                  lineWidth: 0.8
                                              }
                                          ]
                                          }
                                        ]
                                      }
                           ]
                },
                {
                  columns: [  
                  {
                    width: '20%',
                    stack:[' ',' ',
                       'Page ' +currentPage.toString() + ' of ' + pageCount,
                      ],
                    alignment:'left'
                  },
                  {
                    width: '60%',
                    stack:[ footerLine1,
                  footerLine2,
                  '© '+(new Date()).getFullYear()+' DaVita Inc.',
                  ],
                    alignment:'center'
                  },
                  {
                    width: '20%',
                    stack:[ ' ',
                            'Printed',
                             printFooterDate
                  ],
                    alignment:'right'
                  }
                ],
                fontSize: 8,
                color:'gray',
                margin:[35,5,35,5]
              }
              ]
            }


            let customFooter=[];
            if(currentPage==pageCount && showSignature){
              customFooter= [
                {
                  columns:[{
                    width:'100%',
                    stack:['Signatures'
                      ],margin: [ 30, 5, 10, 5 ],bold: true
                    }
                  ]
                 
                },
                {
                  columns:[
                    {
                      stack:['MD:'],
                    width:'5%',
                    alignment:'left'
                  },
                  {
                    width:'55%',
                    stack:['_______________________________________________________________'],
                    
                  }, 
                  {
                    width:'5%',
                    stack:['Date:']
                  },
                  {
                    width:'30%',
                    stack:['_______________________']
                  },            
  
                  ],margin: [ 30, 5, 10, 5 ],fontSize: 9
                },
                {
                  columns:[
                    {
                      stack:['FA:'],
                    width:'5%',
                    alignment:'left'
                  },
                  {
                    width:'55%',
                    stack:['_______________________________________________________________'],
                    
                  }, 
                  {
                    width:'5%',
                    stack:['Date:']
                  },
                  {
                    width:'30%',
                    stack:['_______________________']
                  },            
  
                  ],margin: [ 30, 5, 10, 5 ],fontSize: 9
                },
                {
                  columns:[
                    {
                      stack:['BSS:'],
                    width:'5%',
                    alignment:'left'
                  },
                  {
                    width:'55%',
                    stack:['_______________________________________________________________'],
                    
                  }, 
                  {
                    width:'5%',
                    stack:['Date:']
                  },
                  {
                    width:'30%',
                    stack:['_______________________']
                  },            
  
                  ],margin: [ 30, 5, 10, 0 ],fontSize: 9
                }

                 ]
            }

            return  [
              {                
                  columns:[  customFooter]                
              },
              {                
                columns:[                  
                        { width:'100%',
                                      stack:[
                                        {
                                          canvas: [
                                            {
                                                type: 'line',
                                                x1: 30,
                                                y1: 30,
                                                x2: 755,
                                                y2: 30,
                                                lineWidth: 0.8
                                            }
                                        ]
                                        }
                                      ]
                                    }
                         ],margin:[0,(currentPage==pageCount && showSignature)?0:65,5,0]
              },
              {
                columns: [  
                {
                  width: '20%',
                  stack:[' ',' ',
                     'Page ' +currentPage.toString() + ' of ' + pageCount,
                    ],
                  alignment:'left'
                },
                {
                  width: '60%',
                  stack:[ footerLine1,
                footerLine2,
                '© '+(new Date()).getFullYear()+' DaVita Inc.',
                ],
                  alignment:'center'
                },
                {
                  width: '20%',
                  stack:[ ' ',
                          'Printed',
                           printFooterDate
                ],
                  alignment:'right'
                }
              ],
              fontSize: 8,
              color:'gray',
              margin:[35,(currentPage==pageCount && showSignature)?5:10,35,5]
            }
            ]
          },
        };
        pdfMake.createPdf(dd).open();
        this.pageLoadCompletedEvent.emit();
      }
      catch(ex){
        console.log('error in create pdf'+ex);
      } 
      }, 2000);  
    
  } 
}


